import moment from 'moment';
import { farey } from './utilities';

export const calendar = value => moment(value).calendar();
export const date = (value, format) => moment(value).format(format);

export const fractional = weight => {
  const parts = [];
  const mass = parseFloat(weight);

  parts.push(Math.floor(mass));

  if (mass % 1 > 0) {
    parts.push(farey(mass % 1, 10).join('/'));
  }

  return parts.filter(n => n !== 0).join(' ');
};

export const unitOfMeasure = (value, count = 1, abbreviate = false) => {
  switch (value) {
    case 'lb':
    case 'lbs':
    case 'pound':
    case 'pounds':
      if (count < 2) {
        return abbreviate ? 'lb' : 'pound';
      }

      return abbreviate ? 'lbs' : 'pounds';
    case 'dry oz':
    case 'dry ounce':
    case 'oz':
      if (abbreviate) {
        return 'dry oz';
      }

      return [
        'dry ounce',
        count % 1 === 0 && Math.trunc(count) === 1 ? 's' : '',
      ].join('');
    case 'ea':
    case 'each':
    default:
      return abbreviate ? 'ea' : 'each';
  }
};



// WEBPACK FOOTER //
// ./src/filters.js